module.exports = __webpack_public_path__ + "static/media/pb-5.2a254f1c.png";